import { createSlice } from "@reduxjs/toolkit";

interface ITestState {
  test: string;
}

const initialState: ITestState = {
  test: "test1",
};

export const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    resetTest: () => initialState,
  },
});

export const { resetTest } = testSlice.actions;

export default testSlice.reducer;
